export enum PrizeContextTypeEnum {
  ALL = 'ALL',
  GLOBAL = 'GLOBAL',
  COMPANY = 'COMPANY',
  COMPETITION = 'COMPETITION'
}
